
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: { StoryblokComponent },
  props: {
    blok: { type: Object, default: () => {} },
  },
}
